const Footer = () => (
  <footer className="bg-[#12100E] text-[#F5F3EF] py-14">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
      <div>
        <p className="font-serif-display text-2xl font-semibold" data-testid="footer-logo">
          Ristorante Baracca<span className="text-[#D99B26]">.</span>
        </p>
        <p className="mt-2 font-mono-accent text-[11px] uppercase tracking-[0.25em] text-[#F5F3EF]/50">
          Cucina piemontese · Biella · Dal palazzo dell'800
        </p>
      </div>
      <div className="font-mono-accent text-xs text-[#F5F3EF]/60 leading-loose">
        <p>Via Sant'Eusebio, 12 — 13900 Biella BI</p>
        <p>
          <a href="tel:01521941" data-testid="footer-phone-link" className="hover:text-[#D99B26] transition-colors">
            015 21941
          </a>
          {" · "}Lun–Ven 19:00–21:30
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
